/**
 * Component: FormAnalisisExtraccion
 * Package: AnalisisExtracciones
 * Author: Memorandum Multimedia S.L. - Arturo Soto
 * Copyright  Copyright (c) 2018 - Presente,  Memorandum Multimedia S.L. (https://memorandum.net)
 * License: Privated
 * Since  Version 1.0.0
 * Filesource: \gesipor\front\src\components\analisisExtracciones\FormAnalisisExtraccion.js
 *
 * Requisito funcional: RQ08-002
 *
 * Estado testeado: KO
 *
 * Observaciones: Genera el formulario que permite la inserción y modificación de las extracciones e incluye la trazabilidad material
 * y contaje de maquinas.
 */

import React, { Component } from 'react'
import {SubmissionError,  reduxForm, Field, change} from 'redux-form'
import { Link } from 'react-router-dom'
import { Row, Col, OverlayTrigger, Popover } from 'react-bootstrap'
import { Warning, Close } from '@material-ui/icons'
import Button from '../comun/button/Button'
import ButtonChangeRecord from '../comun/button/ButtonChangeRecord'
import FormGroupSubtitle from '../comun/form/FormGroupSubtitle'
import InputText from '../comun/form/InputText'
import InputNumerical from '../comun/form/InputNumerical'
import InputTextArea from '../comun/form/InputTextArea'
import InputSelect from '../comun/form/InputSelect'
import InputDatePicker from '../comun/form/InputDatePicker'
import InputTime from '../comun/form/InputTime'
import InputCheckBox from '../comun/form/InputCheckBox'
import SimplePage from '../../containers/page/SimplePage'
import SimpleModalPage from '../../containers/comun/modal/SimpleModalPage'
import MensajeAlertaPage from '../../containers/comun/mensajeAlerta/MensajeAlertaPage'
import ModalTrazabilidadMaterialPage from '../../containers/trazabilidadMaterial/ModalTrazabilidadMaterialPage'
import ModalContajeMaquinasPage from '../../containers/analisisExtracciones/ModalContajeMaquinasPage'
import ModalNuevoMagavisionPage from '../../containers/analisisExtracciones/ModalNuevoMagavisionPage'
import ModalDilucionAnalisisExtraccionPage from '../../containers/analisisExtracciones/ModalDilucionAnalisisExtraccionPage'
import ModalPoolAnalisisExtraccionPage from '../../containers/analisisExtracciones/ModalPoolAnalisisExtraccionPage'
import ModalListadoSeguimientoPage from '../../containers/seguimiento/ModalListadoSeguimientoPage'
import './FormAnalisisExtraccion.scss'
import { required } from '../../util/validationFunctions'
import { date_parser, date_formatter, number_formatter, dateTimeZones } from '../../util/formatFunctions'
import { onSubmitFail } from '../../util/util'
import {
  analisisExtraccion as analisisExtraccionConstants, tipoAnalisisExtraccion as tipoAnalisisExtraccionConstants
} from '../../constants/analisis'
import {categorias as categoriasEscandallos} from '../../constants/escandallo'
import {permisos as permisosConstant} from '../../constants/permisos'
import {modulos as modulosConstant} from '../../constants/modulos'
import {tipoAnalisisControlMorfologicoSeguimiento as tipo} from '../../constants/comun'
import CircularProgress from '@material-ui/core/CircularProgress';
import { comboRazonSocialClientesActivos, comboVerraco } from '../../actions/combos/combos'
import operario from '../../reducers/operario/operario'

class FormAnalisisExtraccion extends Component {
  constructor (props) {
    super()
    this.state = {
      analisisExtraccion: analisisExtraccionConstants.TODOS,
      existsAnalisisExtraccion: !!props.match.params.idAnalisisExtraccion,
      idVerraco: null, // Solo es utilizado en la inserción, en la modificación no se puede modificar el verraco.
      idOperario: null, // Solo es utilizado en la inserción, en la modificación no se puede modificar el operario.
      eyaculadoEliminado: false,
      aiStationAbierto: false,
      noAutoEnvasado: false,
      loading: props.match.params.idAnalisisExtraccion ? props.extraccion.loading : false,
      processing: false,
      disabledDosisReales: false,
      customizacionUSA:false     
    }

    this.submitFormAnalisisExtraccion = this.submitFormAnalisisExtraccion.bind(this)
    this.guardarYNuevoAnalisisExtraccion = this.guardarYNuevoAnalisisExtraccion.bind(this)
    this.handleChangeFechaExtraccion = this.handleChangeFechaExtraccion.bind(this)
    this.handleBlurFechaExtraccion = this.handleBlurFechaExtraccion.bind(this)
    this.handleChangeAnalisisExtraccion = this.handleChangeAnalisisExtraccion.bind(this)
    this.handleChangeVerraco = this.handleChangeVerraco.bind(this)
    this.handleBlurVolumen = this.handleBlurVolumen.bind(this)
    this.handleChangeVolumen = this.handleChangeVolumen.bind(this)
    this.handleChangeMotilidadTotal = this.handleChangeMotilidadTotal.bind(this)
    this.handleChangeRectaCalibrado = this.handleChangeRectaCalibrado.bind(this)
    this.handleFocusLecturaColorimetro = this.handleFocusLecturaColorimetro.bind(this)
    this.handleChangeLecturaColorimetro = this.handleChangeLecturaColorimetro.bind(this)
    this.abrirMagavision = this.abrirMagavision.bind(this)
    this.abrirAiStation = this.abrirAiStation.bind(this)
    this.obtenerYGuardarResultadoSistemaAnalisis = this.obtenerYGuardarResultadoSistemaAnalisis.bind(this)
    this.handleChangeDosisReales = this.handleChangeDosisReales.bind(this)
    this.handleChangeTipoDosis = this.handleChangeTipoDosis.bind(this)
    this.handleChangeConcentracionXDosisUtil = this.handleChangeConcentracionXDosisUtil.bind(this)
    this.handleChangeEyaculadoEliminado = this.handleChangeEyaculadoEliminado.bind(this)
    this.handleChangeNoAutoEnvasado = this.handleChangeNoAutoEnvasado.bind(this)
    this.handleOpenModalTrazabilidadMaterial = this.handleOpenModalTrazabilidadMaterial.bind(this)
    this.handleOpenModalListadoSeguimiento = this.handleOpenModalListadoSeguimiento.bind(this)
    this.handleAbrirModalDilucionAnalisisExtraccion = this.handleAbrirModalDilucionAnalisisExtraccion.bind(this)
    this.handleAbrirModalPoolAnalisisExtraccion = this.handleAbrirModalPoolAnalisisExtraccion.bind(this)
    this.handleAnalisisCalcFunctionsOrden = this.handleAnalisisCalcFunctionsOrden.bind(this)
    this.handleChangeOperarioColecta = this.handleChangeOperarioColecta.bind(this)    
    this.handleChangePredilucion = this.handleChangePredilucion.bind(this)

    this.setLecturaRefFn = this.setLecturaRefFn.bind(this)
    this.lecturaRef = null
    
    this.operarioColectaRef = React.createRef();

    this.setRfidRefFn = this.setRfidRefFn.bind(this)
    this.rfidRef = null;

    this.oldMagavisionAbierto = false
    this.evaluacionPulsado = false

    this.magavisionMLAbierto = false

    this.aiStationPeticionAnalisis = false

    this.textInput = React.createRef();
    this.focusTextInput = this.focusTextInput.bind(this);

    this.timeOut =  0;
    this.timeOutRfid =  0;
  }

  focusTextInput() {
    // Explicitly focus the text input using the raw DOM API
    // Note: we're accessing "current" to get the DOM node
    this.textInput.current.focus();
  }


  setLecturaRefFn (ref) {
    return this.lecturaRef = ref
  }

  setRfidRefFn (ref) {
    return this.rfidRef = ref
  }

  handleChangeFechaExtraccion () {
    if (this.state.analisisExtraccion === analisisExtraccionConstants.PREVISTO) {
      this.props.actions.updateComboVerraco()
    } else if (this.state.idVerraco) {
      this.props.actions.fetchDatosVerracoExtracciones(this.state.idVerraco, !!this.props.match.params.idAnalisisExtraccion)
    }
  }

  handleBlurFechaExtraccion (val) {
    if (!val) {
      this.props.actions.yesNoModal('fechaExtraccionRequerido', () => {
        let currentDate = new Date()
        currentDate = date_parser(currentDate, this.props.auth.formaFechaHora)
        this.props.change('fechaExtraccion', currentDate)
        this.handleChangeFechaExtraccion()
      })
    }
  }

  handleChangeAnalisisExtraccion (analisisExtraccion) {
    if (this.state.analisisExtraccion !== analisisExtraccion.value) {
      this.setState({analisisExtraccion: analisisExtraccion.value})
      this.props.actions.updateComboVerraco()
    }
  }

  handleChangeVerraco (verraco, crotalRef = false) {
    if (verraco) {
      // Si tenemos verraco es una modificacion y necesitariamos disparar algunos valores como el inicio de extraccion
      this.setState({idVerraco: verraco.value}, () => {
        this.props.actions.fetchDatosVerracoExtracciones(verraco && verraco.value, !!this.props.match.params.idAnalisisExtraccion)
      })
      console.log(this.operarioColectaRef)
      this.operarioColectaRef.current.focus();
    } else {
      this.setState({idVerraco: null})
    }
  }

  handleChangeOperarioColecta (operarioColecta){
    if (operarioColecta) {
      this.setState({idOperario: operarioColecta.value}, () => {
        this.props.actions.fetchDatosOperarioExtraccion(operarioColecta && operarioColecta.value)
      })

      if(this.state.customizacionUSA /*|| this.props.auth.version >= 2*/){        
        this.checkVolumen()
        if (this.props.formAnalisisExtraccion.tipoAnalisis.value == tipoAnalisisExtraccionConstants.MAGAVISION_ML) {
          this.props.actions.abrirMagavision(tipoAnalisisExtraccionConstants.MAGAVISION_ML, false)
        } else {
          this.props.actions.abrirMagavision(tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION, false)
        }
      }
    }
  }


  checkVolumen (){
    this.props.actions.abrirBascula()
  }

  lecturaRFIDAnalisis(){
    this.props.actions.lecturaRFIDAnalisis()
  }

  handleKeyDownCrotal(value){
    if(this.timeOut) clearTimeout(this.timeOut);
    this.timeOut = setTimeout(() => {      
      value.eventValue.preventDefault()
      this.props.actions.fetchVerracoCrotal(value.inputValue.replace(/(\r\n|\n|\r)/gm, "").trim(), !!this.props.match.params.idAnalisisExtraccion)
      // this.focusTextInput()
    }, 300);
    
    // if(value.eventValue.key === "Tab"){
    //   value.eventValue.preventDefault()
    //   this.props.actions.fetchVerracoCrotal(value.inputValue, !!this.props.match.params.idAnalisisExtraccion)
    //   // var verraco = {value: 274, label: 'DU00000_1'}
    //   // this.props.change('idVerraco', verraco)
    //   // this.handleChangeVerraco(verraco, true)
    //   this.focusTextInput()
    // }
  };

  handleKeyDownRfid(value){       
    if(this.timeOutRfid) clearTimeout(this.timeOutRfid);
    this.timeOutRfid = setTimeout(() => {
      value.eventValue.preventDefault()
      this.props.actions.fetchOperarioRfid(value.inputValue.replace(/(\r\n|\n|\r)/gm, "").trim(), !!this.props.match.params.idAnalisisExtraccion)
    }, 300);

    // if(value.key === "Tab"){      
    //   value.preventDefault()
    //   this.props.actions.fetchOperarioRfid(value.target.value, !!this.props.match.params.idAnalisisExtraccion)
    // }
    // if(value.eventValue.key === "Tab"){
    //   value.eventValue.preventDefault()
    //   this.props.actions.fetchOperarioRfid(value.inputValue, !!this.props.match.params.idAnalisisExtraccion)
    // }
  };

  handleChangeVolumen (val) {
    if (!this.state.loading) {
      let calcFunctionList = [
        {name: 'calcNumeroDosis', args: {updateAllDosis: true, useTipoDosisConcentracion: true}},
        {name: 'reCalcConcentracionXDosis'},
        {name: 'calcVolumenDiluyente'}
      ]
      this.handleAnalisisCalcFunctionsOrden(calcFunctionList, {caller: 'handleChangeVolumen'})

      if (val && !this.props.formAnalisisExtraccion.horaInicioProcesado) {
        let currentTime = new Date()
        let hours, minutes
        hours = currentTime.getHours()
        minutes = currentTime.getMinutes()
        if (hours < 10) hours = '0' + hours
        if (minutes < 10) minutes = '0' + minutes
        currentTime = hours + ':' + minutes
        this.props.untouch('horaInicioProcesado')
        this.props.change('horaInicioProcesado', currentTime)
      }
    }
  }

  handleBlurVolumen (val) {
    const tKeyNombreCampo = 'ANALISIS_EXTRACCIONES.FORM.FORM.VOLUMEN'
    let tKeyMensajeAlerta = ''
    let dynamicMessage = ''
    if (val && val < parseFloat(this.props.panelControl.AlertaVolumenMinimo)) {
      tKeyMensajeAlerta = 'SIMPLE_MODAL.INFERIOR_AL_LIMITE'
      dynamicMessage = this.props.t(tKeyMensajeAlerta, {nombreCampo: this.props.t(tKeyNombreCampo), value: this.props.panelControl.AlertaVolumenMinimo})
      this.props.actions.yesNoModal('fueraLimite', null, null, dynamicMessage)   
      this.props.change('showAlerta', true)         
    } else if (val && val > parseFloat(this.props.panelControl.AlertaVolumenMaximo)) {
      tKeyMensajeAlerta = 'SIMPLE_MODAL.SUPERIOR_AL_LIMITE'
      dynamicMessage = this.props.t(tKeyMensajeAlerta, {nombreCampo: this.props.t(tKeyNombreCampo), value: this.props.panelControl.AlertaVolumenMaximo})
      this.props.actions.yesNoModal('fueraLimite', null, null, dynamicMessage)   
      this.props.change('showAlerta', true)     
    }
  }

  handleChangeMotilidadTotal (val) {
    if (!this.state.loading) {
      let calcFunctionList = [
        {name: 'calcConcentracionUtil'},
        {name: 'calcConcentracionXDosis'},
        {name: 'calcNumeroDosis', args: {updateAllDosis: true, useTipoDosisConcentracion: true}},
        {name: 'reCalcConcentracionXDosis'},
        {name: 'calcVolumenDiluyente'},
        {name: 'callback', fn: () => {
          const tKeyNombreCampo = 'ANALISIS_EXTRACCIONES.FORM.FORM.MOTILIDAD_PERCENT'
          let tKeyMensajeAlerta = ''
          let dynamicMessage = ''
          if (val && val < parseFloat(this.props.panelControl.AlertaMotilidadMinima)) {
            tKeyMensajeAlerta = 'SIMPLE_MODAL.INFERIOR_AL_LIMITE'
            dynamicMessage = this.props.t(tKeyMensajeAlerta, {nombreCampo: this.props.t(tKeyNombreCampo), value: this.props.panelControl.AlertaMotilidadMinima})
            this.props.actions.yesNoModal('fueraLimite', null, null, dynamicMessage)            
            this.props.change('showAlerta', true)  
          } else if (val && val > parseFloat(this.props.panelControl.AlertaMotilidadMaxima)) {
            tKeyMensajeAlerta = 'SIMPLE_MODAL.SUPERIOR_AL_LIMITE'
            dynamicMessage = this.props.t(tKeyMensajeAlerta, {nombreCampo: this.props.t(tKeyNombreCampo), value: this.props.panelControl.AlertaMotilidadMaxima})
            this.props.actions.yesNoModal('fueraLimite', null, null, dynamicMessage)            
            this.props.change('showAlerta', true)  
          }
        }}
      ]
      this.handleAnalisisCalcFunctionsOrden(calcFunctionList, {caller: 'handleChangeMotilidadTotal'})
    }
  }

  handleChangeRectaCalibrado () {
    if (!this.state.loading) {
      let calcFunctionList = [
        {name: 'calcConcentracionTotal'},
        {name: 'calcConcentracionUtil'},
        {name: 'calcConcentracionXDosis'},
        {name: 'calcNumeroDosis', args: {updateAllDosis: true, useTipoDosisConcentracion: false}},
        {name: 'reCalcConcentracionXDosis'},
        {name: 'calcVolumenDiluyente'}
      ]
      this.handleAnalisisCalcFunctionsOrden(calcFunctionList, {caller: 'handleChangeRectaCalibrado'})
    }
  }

  handleFocusLecturaColorimetro (val) {
    if (!this.props.formAnalisisExtraccion.volumen || this.props.formAnalisisExtraccion.volumen <= 0) {
      this.props.actions.yesNoModal('volumenRequerido')
      this.lecturaRef.blur()
    } else if (!this.props.formAnalisisExtraccion.idVerraco) {
      this.props.actions.yesNoModal('verracoRequerido')
      this.lecturaRef.blur()
    } else if (!this.props.formAnalisisExtraccion.rectaCalibrado || !this.props.formAnalisisExtraccion.rectaCalibrado.value) {
      this.props.actions.yesNoModal('rectaRequerido')
      this.lecturaRef.blur()
    }
  }

  handleChangeLecturaColorimetro (val) {
    if (!this.state.loading) {
      let calcFunctionList = [
        {name: 'calcConcentracionTotal'},
        {name: 'calcConcentracionUtil'},
        {name: 'calcConcentracionXDosis'},
        {name: 'calcNumeroDosis', args: {updateAllDosis: true, useTipoDosisConcentracion: (val === "" ? true : false)}},
        {name: 'reCalcConcentracionXDosis'},
        {name: 'calcVolumenDiluyente'}
      ]
      this.handleAnalisisCalcFunctionsOrden(calcFunctionList, {caller: 'handleChangeLecturaColorimetro'})
    }

  }

  abrirMagavision(tipoAnalisis) {
    if (!this.props.formAnalisisExtraccion.volumen || this.props.formAnalisisExtraccion.volumen <= 0) {
      this.props.actions.yesNoModal('volumenRequerido')
    } else if (!this.props.formAnalisisExtraccion.idVerraco) {
      this.props.actions.yesNoModal('verracoRequerido')
    } else if (tipoAnalisis === tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION && !this.props.panelControl.urlMagavision) {
      this.props.actions.yesNoModal('urlMagavisionRequerido')
    } else {
      if (this.oldMagavisionAbierto == false && this.magavisionMLAbierto == false) {            
        this.props.actions.abrirMagavision(tipoAnalisis, false)     
      } else {        
        this.props.actions.yesNoModal('alertaOldMagavisionAbierto')        
      }
      if (tipoAnalisis == tipoAnalisisExtraccionConstants.MAGAVISION_I || tipoAnalisis == tipoAnalisisExtraccionConstants.MAGAVISION_M) {        
        this.oldMagavisionAbierto = true
      } 
      if (tipoAnalisis == tipoAnalisisExtraccionConstants.MAGAVISION_ML) {
        this.magavisionMLAbierto = true
      }
    }
  }

  abrirAiStation() {
    if (!this.props.formAnalisisExtraccion.volumen || this.props.formAnalisisExtraccion.volumen <= 0) {
      this.props.actions.yesNoModal('volumenRequerido')
    } else if (!this.props.formAnalisisExtraccion.idVerraco) {
      this.props.actions.yesNoModal('verracoRequerido')
    }else {
      if (!this.state.aiStationAbierto) {            
        this.props.actions.abrirAiStation()     
      } else {        
        this.props.actions.yesNoModal('alertaAiStationAbierto')        
      }
      this.setState({ aiStationAbierto: true })
    }
  }

  getAnalisisAiStation() {  
      if (this.aiStationPeticionAnalisis == false) {        
        this.props.actions.getAnalisisAiStation()     
      } else {        
        this.props.actions.yesNoModal('alertaAiStationAbierto')        
      }
      this.aiStationPeticionAnalisis = true
  }

  verInformeMagavision() {
    this.props.actions.verInformeMagavision() 
  }

  obtenerYGuardarResultadoSistemaAnalisis () {
    if (!this.props.formAnalisisExtraccion.volumen || this.props.formAnalisisExtraccion.volumen <= 0) {
      this.props.actions.yesNoModal('volumenRequerido')
    } else if (!this.props.formAnalisisExtraccion.idVerraco) {
      this.props.actions.yesNoModal('verracoRequerido')
    } else {      
      let tipoAnalisisSeleccionado = this.props.extraccion.tipoAnalisisSeleccionado || parseInt(this.props.panelControl.tipoAnalisisPredeterminado)  
      this.evaluacionPulsado = true
      this.props.actions.obtenerYGuardarResultadoSistemaAnalisis(tipoAnalisisSeleccionado, false)
    }
  }

  handleChangeTipoDosis () {
    if (!this.state.loading) {
      let calcFunctionList = [
        {name: 'calcConcentracionXDosis'},
        {name: 'calcNumeroDosis', args: {updateAllDosis: true, useTipoDosisConcentracion: false}},
        {name: 'reCalcConcentracionXDosis'},
        {name: 'calcVolumenDiluyente'}
      ]
      this.handleAnalisisCalcFunctionsOrden(calcFunctionList, {caller: 'handleChangeTipoDosis'})

      if (this.props.auth.modulos.includes(modulosConstant.TRAZABILIDAD_BIOSEGURIDAD)) {
        this.props.actions.comprobarStockTrazabilidad(categoriasEscandallos.ANALISIS, this.props.formAnalisisExtraccion.tipoDosis.value)
        this.props.actions.obtenerLotesEscandalloAnalisis({
          idTipoDosis: this.props.formAnalisisExtraccion.tipoDosis.value,
          idCategoria: categoriasEscandallos.ANALISIS,
          idAnalisis: this.props.match.params.idAnalisisExtraccion || null,
        })
      }
    }
  }

  handleChangeConcentracionXDosisUtil () {
    if (!this.state.loading) {
      let calcFunctionList = [
        {name: 'calcNumeroDosis', args: {updateAllDosis: true, useTipoDosisConcentracion: false}}
      ]
      this.handleAnalisisCalcFunctionsOrden(calcFunctionList, {caller: 'handleChangeConcentracionXDosisUtil'})
    }
  }

  handleChangeDosisReales (value) {
    if (!this.state.loading) {
      if (value === '0') {
        this.props.change('volumenDiluyente', 0)
      } else {
        let calcFunctionList = [
          {name: 'reCalcConcentracionXDosis'},
          {name: 'calcVolumenDiluyente'}
        ]
        this.handleAnalisisCalcFunctionsOrden(calcFunctionList, {caller: 'handleChangeDosisReales'})
      }
    }
  }

  handleChangeEyaculadoEliminado (value) {
    this.setState({eyaculadoEliminado: value})
    if (value === true) {
      this.props.change('dosisReales', 0)
      this.props.change('dosisRealesPredeterminadas', 0)
      this.setState({disabledDosisReales: true})
    } else {
      this.setState({disabledDosisReales: false})
      this.props.change('dosisReales', this.props.formAnalisisExtraccion.dosisTeoricas)
      this.props.change('dosisRealesPredeterminadas', this.props.formAnalisisExtraccion.dosisTeoricasPredeterminadas)
    }
  }

  handleChangeNoAutoEnvasado (value) {
    this.setState({noAutoEnvasado: value})    
  }

  handleOpenModalListadoSeguimiento () {
    this.props.actions.openModalListadoSeguimiento(this.props.match.params.idAnalisisExtraccion, null)
  }

  handleOpenModalTrazabilidadMaterial () {
    if (this.props.formAnalisisExtraccion.tipoDosis) {
      this.props.actions.openModalTrazabilidadMaterial({
        idTipoDosis: this.props.formAnalisisExtraccion.tipoDosis.value,
        idCategoria: categoriasEscandallos.ANALISIS,
        idAnalisis: this.props.match.params.idAnalisisExtraccion || null,
        disabled: this.props.extraccion.data ? this.props.extraccion.data.diluido : false,
        showStockColumns: !(this.props.extraccion.data && this.props.extraccion.data.trazabilidad),
        creadoDesdeFoso: this.props.extraccion.data ? this.props.extraccion.data.creadoDesdeFoso : false
      })
    }
  }

  handleAbrirModalDilucionAnalisisExtraccion () {
    if (!this.props.formAnalisisExtraccion.volumen || this.props.formAnalisisExtraccion.volumen <= 0) {
      this.props.actions.yesNoModal('volumenRequerido')
    } else if (!this.props.formAnalisisExtraccion.idVerraco) {
      this.props.actions.yesNoModal('verracoRequerido')
    } else if (!this.props.formAnalisisExtraccion.volumenDiluyente || this.props.formAnalisisExtraccion.volumenDiluyente <= 0) {
      this.props.actions.yesNoModal('volumenDiluyenteRequerido')
    } else {
      this.props.actions.abrirModalDilucionAnalisisExtraccion()
    }
  }

  handleAbrirModalPoolAnalisisExtraccion () {
    if (!this.props.formAnalisisExtraccion.volumen || this.props.formAnalisisExtraccion.volumen <= 0) {
      this.props.actions.yesNoModal('volumenRequerido')
    } else if (!this.props.formAnalisisExtraccion.idVerraco) {
      this.props.actions.yesNoModal('verracoRequerido')
    } else if (!this.props.formAnalisisExtraccion.volumenDiluyente || this.props.formAnalisisExtraccion.volumenDiluyente <= 0) {
      this.props.actions.yesNoModal('volumenDiluyenteRequerido')
    } else {
      this.props.actions.abrirModalPoolAnalisisExtraccion()
    }
  }

  handleAnalisisCalcFunctionsOrden (calcFunctionList, caller) {
    // this.setState({processing: true})
    // calcFunctionList.push({name: 'callback', fn: () => {this.setState({processing: false})}})
    this.props.actions.handleAnalisisCalcFunctionsOrden(calcFunctionList, caller)
  }

  handleChangePredilucion (val) {
    if (!this.state.loading) {
      let calcFunctionList = [        
        {name: 'calcVolumenDiluyente'}
      ]
      this.handleAnalisisCalcFunctionsOrden(calcFunctionList, {caller: 'handleChangePredilucion'})      
    }
  }

  submitFormAnalisisExtraccion (values) {   
    // ELIMINAR DATOS DILUCION.
    // TODO QUITAR DE ESTE COMPONENTE EL FORMULARIO DE DILUCION.    
    if (values.dilucion) {
      values.dilucion = null
    }
    values.noAutoEnvasado = this.state.noAutoEnvasado
    values.showAlerta = this.props.showAlerta
    //console.log(values)       
    if (this.oldMagavisionAbierto == true && this.evaluacionPulsado == false) {   
      this.props.actions.yesNoModal('alertaEvaluacion')  
      return false
    }          
    return new Promise((resolve, reject) => {      
      this.props.actions.submitFormAnalisisExtraccion(values, this.props.match.params.idAnalisisExtraccion || null, this.props.history, () => {
        this.setState({noAutoEnvasado: false})
        resolve()
      }, reject)
    })
    .then(() => { console.log('completado') })
    .catch(() => { console.log('error') })
  }

  guardarYNuevoAnalisisExtraccion (values) {
    // ELIMINAR DATOS DILUCION.
    // TODO QUITAR DE ESTE COMPONENTE EL FORMULARIO DE DILUCION.
    if (values.dilucion) {
      values.dilucion = null
    }
    values.noAutoEnvasado = this.state.noAutoEnvasado
    //console.log(values)    
    this.oldMagavisionAbierto = false
    this.magavisionMLAbierto = false
    values.nuevoAnalisis = true    
    if (this.oldMagavisionAbierto == true && this.evaluacionPulsado == false) {   
      this.props.actions.yesNoModal('alertaEvaluacion')  
      return false
    }
    if (values.idAnalisis) {
      return new Promise((resolve, reject) => {
        this.props.actions.submitFormAnalisisExtraccion(values, this.props.match.params.idAnalisisExtraccion || null, this.props.history, () => {
          this.setState({noAutoEnvasado: false})
          resolve()
        }, reject)
      })
      .then(() => { console.log('completado') })
      .catch(() => { console.log('error') })
    } else {
      return new Promise((resolve, reject) => {
        this.props.actions.submitFormAnalisisExtraccion(values, this.props.match.params.idAnalisisExtraccion || null, false, () => {
          this.setState({eyaculadoEliminado: false})
          this.setState({noAutoEnvasado: false})
          resolve()
        }, reject)
      })
      .then(() => { console.log('completado') })
      .catch(() => { console.log('error') })
    }
  }

  componentDidMount () {
    (this.props.auth.customizations && this.props.auth.customizations.find((customization) => {return customization=='USA'})) ? (       
      this.setState({customizacionUSA: true})) 
    :(
      this.setState({customizacionUSA: false})
    )
    this.props.actions.comboVerraco({},true);    
    if (this.state.existsAnalisisExtraccion) {
      this.props.actions.recuperarDatosFormAnalisisExtraccion(this.props.match.params.idAnalisisExtraccion) // En este action se cargan los combos.
      let fechaActual = date_parser(new Date(), this.props.auth.formaFechaHora)
      this.props.actions.fetchAnalisisExtracciones(this.props.filtros || {desde: fechaActual, 'seleccionar-todo': false})

    }else {
      let currentDate = dateTimeZones(this.props.auth.zonaHorariaString)
      currentDate = date_parser(currentDate, this.props.auth.formaFechaHora)
      let initialValues = {
        fechaExtraccion: currentDate,
        eyaculadoEliminado: false,
      }      

      if (this.props.panelControl.tipoAnalisisPredeterminado && this.props.panelControl.tipoAnalisisPredeterminado != null) {
        let tipoAnalisisPredeterminado = this.props.combos.comboTipoAnalisisExtraccion.find((tipoAnalisisExtraccionItem) => {
          return tipoAnalisisExtraccionItem.value === parseInt(this.props.panelControl.tipoAnalisisPredeterminado)
        })
        initialValues.tipoAnalisis = {value: tipoAnalisisPredeterminado.value, label: this.props.t(`COMUN.COMBOS.${tipoAnalisisPredeterminado.label}`)}
      }
      this.props.initialize(initialValues)
      this.props.actions.initializeFormAnalisisExtraccion()
      // this.props.actions.fetchCodigoAnalisisExtracciones()
      // this.props.actions.comboVerraco({analisisExtraccion: this.props.combos.comboAnalisisExtraccion[0].value}, true)
    }
  }

  componentDidUpdate (prevProps) {
    // este if es para cuando el volumen ya esta debido a que es una extraccion de foso, y disparamos el handler de cambio de volumen que inicializa la hora del analisis
    if (this.props.formAnalisisExtraccion != null && this.props.formAnalisisExtraccion.volumen !== prevProps.match.params.volumen && this.props.formAnalisisExtraccion.volumen != null && this.props.formAnalisisExtraccion.horaInicioProcesado==null){            
      this.handleChangeVolumen(this.props.formAnalisisExtraccion.volumen);
    }
    if (this.props.match.params.idAnalisisExtraccion !== prevProps.match.params.idAnalisisExtraccion) {
      this.props.actions.recuperarDatosFormAnalisisExtraccion(this.props.match.params.idAnalisisExtraccion) // En este action se cargan los combos.
    }
    if (this.props.match.params.idAnalisisExtraccion && this.props.extraccion.loading !== prevProps.extraccion.loading) {
      this.setState({        
        loading: this.props.extraccion.loading        
      })      
    }    

    if (
      this.props.extraccion.data && this.props.extraccion.data.eyaculadoEliminado !== (!!prevProps.extraccion.data && prevProps.extraccion.data.eyaculadoEliminado) &&
      this.props.extraccion.data.eyaculadoEliminado !== this.state.eyaculadoEliminado
    ) {
      this.setState({eyaculadoEliminado: this.props.extraccion.data.eyaculadoEliminado})
    }

    if (!this.state.existsAnalisisExtraccion && this.props.panelControl.tipoAnalisisPredeterminado && this.props.panelControl.tipoAnalisisPredeterminado != null
        && this.props.panelControl.tipoAnalisisPredeterminado !== undefined
        && this.props.panelControl.tipoAnalisisPredeterminado !== prevProps.panelControl.tipoAnalisisPredeterminado) {
      let tipoAnalisisPredeterminado = this.props.combos.comboTipoAnalisisExtraccion.find((tipoAnalisisExtraccionItem) => {
        return tipoAnalisisExtraccionItem.value === parseInt(this.props.panelControl.tipoAnalisisPredeterminado)
      })
      this.props.change('tipoAnalisis', {value: tipoAnalisisPredeterminado.value, label: this.props.t(`COMUN.COMBOS.${tipoAnalisisPredeterminado.label}`)})
    }

    if (!this.state.existsAnalisisExtraccion && (!prevProps.match.params.idAnalisisExtraccion && !!this.props.match.params.idAnalisisExtraccion)) {
      this.setState({existsAnalisisExtraccion: true})
    }

    if (this.props.formAnalisisExtraccion != null && this.props.formAnalisisExtraccion.idVerracoRFID != null && this.props.formAnalisisExtraccion.idVerracoRFID !== prevProps.formAnalisisExtraccion.idVerracoRFID){            
      //console.log('cambio idVerracoRFID '+this.props.formAnalisisExtraccion.idVerracoRFID)
      let idVerracoRFID = this.props.formAnalisisExtraccion.idVerracoRFID
      let verraco = null
      this.props.combos.comboVerraco.forEach(v => {
        if(v.value == idVerracoRFID) verraco = v
      });
      if(verraco != null){
        this.props.change('idVerraco', verraco)
        this.handleChangeVerraco(verraco)
      } 
    }
  }

  componentWillUnmount() {
    this.props.actions.initializeFormAnalisisExtraccionSuccess()
  }

  pdfEtiquetaExtraccion () {
    this.props.actions.pdfEtiquetaExtraccion(this.props.match.params.idAnalisisExtraccion)
  }

  imprimirEtiquetaPDF () {
    this.props.actions.imprimirEtiquetaPDF(this.props.match.params.idAnalisisExtraccion)
  }
  
  imprimirMiniEtiquetaAnalisis(){
    this.props.actions.imprimirMiniEtiquetaAnalisis(this.props.match.params.idAnalisisExtraccion)
  }

  imprimirMiniEtiquetaPool(){
    this.props.actions.imprimirMiniEtiquetaPool(this.props.formAnalisisExtraccion.idPool)
  }

  render () {
    const {
      t, handleSubmit, extraccion, list, stockInsuficiente, submitting, showModalFormSeguimiento,
      auth: {formaFechaHora, separadorDec, separadorMil, customizations, version},
      combos: {comboVerraco, comboOperarioPredeterminado, comboRectaCalibrado, comboTipoDosis, comboTipoDiluyente, comboOperarioActivo, comboObservacionesEyaculadoEliminado},
      actions: {
        recuperarDatosFormAnalisisExtraccion, openModalContajeMaquinas, changeTipoAnalisisExtraccion
      }
    } = this.props    
    const tKey = 'ANALISIS_EXTRACCIONES.FORM.'
    const tipoAnalisisSeleccionado = this.props.extraccion.tipoAnalisisSeleccionado || parseInt(this.props.panelControl.tipoAnalisisPredeterminado)
    const diluido = extraccion.data && extraccion.data.diluido
    const operarioProcesadoDisabled = diluido || this.props.auth.customizations?.includes("FDA")
    const envasado = extraccion.data && extraccion.data.envasado
    const checkAlbaran = extraccion.data && extraccion.data.checkAlbaran && extraccion.data.checkAlbaran > 0
    const checkOneDilucion = extraccion.data && extraccion.data.checkOneDilucion
    const checkOneEnvasado = extraccion.data && extraccion.data.checkOneEnvasado
    let disabledTipoDosis = false
    if(this.state.existsAnalisisExtraccion){
      if(this.state.customizacionUSA || version >= 2){
        disabledTipoDosis = !(!envasado && (checkOneDilucion && checkOneEnvasado))
      }else{
        disabledTipoDosis = diluido
      }
    }
    // console.log('diluido',diluido)
    // console.log('envasado',envasado)
    // console.log('checkOneDilucion',checkOneDilucion)
    // console.log('checkOneEnvasado',checkOneEnvasado)
    // console.log('disabledTipoDosis',disabledTipoDosis)

    let disableVerraco = this.state.existsAnalisisExtraccion || diluido
    if(this.state.customizacionUSA || version >= 2){
      disableVerraco = checkAlbaran//Si está en albarán se bloquea
    }

    let comboAnalisisExtraccion = this.props.combos.comboAnalisisExtraccion
    comboAnalisisExtraccion = comboAnalisisExtraccion.map((analisisExtraccionItem) => {
      return {...analisisExtraccionItem, label: t(`COMUN.COMBOS.${analisisExtraccionItem.label}`)}
    })

    let comboTipoAnalisisExtraccion = this.props.combos.comboTipoAnalisisExtraccion
    comboTipoAnalisisExtraccion = comboTipoAnalisisExtraccion.map((tipoAnalisisExtraccionItem) => {
      //tipoAnalisisExtraccionItem.predeterminado = tipoAnalisisExtraccionItem.value === tipoAnalisisSeleccionado
      return {...tipoAnalisisExtraccionItem, label: t(`COMUN.COMBOS.${tipoAnalisisExtraccionItem.label}`)}
    })

    // let comboObservacionesEyaculadoEliminado = this.props.combos.comboObservacionesEyaculadoEliminado
    // comboObservacionesEyaculadoEliminado = comboObservacionesEyaculadoEliminado.map((observacionesEyaculadoEliminadoItem) => {
    //   return {...observacionesEyaculadoEliminadoItem, label: t(`COMUN.COMBOS.${observacionesEyaculadoEliminadoItem.label}`)}
    // })

    let comboOperarioPre = comboOperarioPredeterminado.map((item) => {
      return {value: item.value, label: item.label}
    })

    let comboOperarioPro = comboOperarioActivo.filter(item => item.procesado===true)
    let comboOperarioProcesado = comboOperarioPro.map((item) => {
      return {value: item.value, label: item.label, predeterminado: comboOperarioPredeterminado.filter(itemInt => itemInt.value===item.value)[0].predeterminado}
    })

    let idMotilidad, nameMotilidad
    switch(tipoAnalisisSeleccionado) {
      case tipoAnalisisExtraccionConstants.COLORIMETRO:
      case tipoAnalisisExtraccionConstants.CAMARA_BURKER:
        idMotilidad = 'motilidadTotal'
        nameMotilidad = this.props.t('INFORMES.EXTRACCIONES.TABLA.MOTILIDAD')
        break
      case tipoAnalisisExtraccionConstants.MAGAVISION_I:
      case tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION:
      case tipoAnalisisExtraccionConstants.MAGAVISION_ML:
        idMotilidad = 'mt'
        nameMotilidad = this.props.t('INFORMES.EXTRACCIONES.TABLA.MT')
        break
      case tipoAnalisisExtraccionConstants.MAGAVISION_M:
        idMotilidad = 'motilidadMasal'
        nameMotilidad = this.props.t('INFORMES.EXTRACCIONES.TABLA.MOT_MASAL')
    }

    return (
      <div>

       
      <SimplePage noTitle={true} extraClassName="form-analisis-extracciones">
        
        <ModalNuevoMagavisionPage from={tipo.ANALISIS} isPool={false} isSeguimiento={showModalFormSeguimiento} />
        <SimpleModalPage/>
        <MensajeAlertaPage/>

        <form>
          <Row>       
            <Col sm={12}>
              <h2 className="page-title">
                {t(tKey + (this.state.existsAnalisisExtraccion ? 'TITLE_MODIFICAR' : 'TITLE_NUEVO'))}
                {this.props.match.params.idAnalisisExtraccion && (
                  <ButtonChangeRecord list={list} idElemento="idAnalisis" currentId={this.props.match.params.idAnalisisExtraccion} getNextRecord={(idAnalisis) => {
                    recuperarDatosFormAnalisisExtraccion(idAnalisis)
                    window.location.href='/#/EditarAnalisisExtraccion/' + idAnalisis
                  }} />
                )}
                <span className="cierre-ventana-extracciones"><Link to={{pathname: '/AnalisisExtracciones', state: { from: this.props.location.pathname }}}><Close/></Link></span>
              </h2>
            </Col>            
          </Row>
          { this.state.loading ? (
          <div className="loading-screen">
            <CircularProgress />
          </div>    
            ) : ( 
          <div> 
          

     <Row>
      <Col sm={12}>

         <Row>
           <Col sm={8}>

            <Row>           
              <Field
                colSm={3}
                id="fechaExtraccion"
                name="fechaExtraccion"
                controlLabel={t(tKey + 'FORM.FECHA_EXTRACCION') + '*'}
                component={InputDatePicker}
                onInputChange={(fechaExtraccion) => this.handleChangeFechaExtraccion(fechaExtraccion)}
                validate={required}             
                disabled={this.state.existsAnalisisExtraccion || diluido}
                onInputBlur={this.handleBlurFechaExtraccion}
              />
              <Field
                colSm={3}
                id="analisisExtraccion"
                name="analisisExtraccion"
                controlLabel={t(tKey + 'FORM.ANALISIS')}
                component={InputSelect}
                options={comboAnalisisExtraccion}
                valueKey="value"
                labelKey="label"
                isClearable={false}
                isSmall={true}
                onInputChange={(analisisExtraccion) => this.handleChangeAnalisisExtraccion(analisisExtraccion)}
                disabled={this.state.existsAnalisisExtraccion || diluido}
              />
              <Field
                colSm={3}
                id="idVerraco"
                name="idVerraco"
                controlLabel={t(tKey + 'FORM.VERRACO') + '*'}
                component={InputSelect}
                options={comboVerraco}
                valueKey="value"
                labelKey="label"
                isSmall={true}
                validate={required}
                onInputChange={(verraco) => {this.handleChangeVerraco(verraco)}}
                disabled={disableVerraco}
              />
              <Field
                colSm={3}
                id="crotal"
                name="crotal"
                controlLabel={t('FICHA_VERRACO.NUEVO_VERRACO.GENERAL.CROTAL')}
                component={InputText}
                onInputChangeDelay={true}
                autoComplete="off"
                onKeyDown={(event) => {this.handleKeyDownCrotal(event)}}
              />
            </Row>
            <Row>
            <Field
                colSm={3}
                id="operarioColecta"
                name="operarioColecta"
                controlLabel={t(tKey + 'FORM.OPERARIO_COLECTA')}
                component={InputSelect}
                options={comboOperarioPre}
                valueKey="value"
                labelKey="label"
                isSmall={true}
                disabled={diluido}
                onInputChange={(operarioColecta) => {this.handleChangeOperarioColecta(operarioColecta)}}
                setMyRef={this.operarioColectaRef}
              />
              <Field
                colSm={3}
                id="rfid"
                name="rfid"
                controlLabel={t(tKey + 'FORM.OPERARIO_COLECTA') + " RFID"}
                component={InputText}
                //onInputChange={(event, val) => this.handleChangeVolumen(val)}
                onInputChangeDelay={true}
                numDecimales={0}
                autoComplete="off"
                onKeyDown={(event) => {this.handleKeyDownRfid(event)}}
              />
              {/* <Col sm={3}>
                <div className="form-group">
                  <label className="control-label">{t(tKey + 'FORM.OPERARIO_COLECTA') + " RFID"}</label>
                  <input title={t(tKey + 'FORM.OPERARIO_COLECTA') + " RFID"}  type="text" id="rfid" name="rfid" className="form-control" ref={this.textInput} onKeyDown={(event) => {this.handleKeyDownRfid(event)}}/> 
                </div>
            
              </Col> */}
              
              <Field
                colSm={3}
                id="operarioProcesado"
                name="operarioProcesado"
                controlLabel={t(tKey + 'FORM.OPERARIO_PROCESADO')}
                component={InputSelect}
                options={comboOperarioProcesado}
                valueKey="value"
                labelKey="label"
                isSmall={true}
                disabled={operarioProcesadoDisabled}
              />              
              {(extraccion.data.nombrePool || ('' + extraccion.data.nombrePool === '0')) && (
                <Field
                  colSm={3}
                  id="nombrePool"
                  name="nombrePool"
                  controlLabel={t(tKey + 'FORM.POOL')}
                  component={InputText}
                  disabled={true}
                />
              )}
              {extraccion.verraco && (
                <Col sm={3}>
                  <OverlayTrigger trigger={["click"]} placement="bottom" rootClose overlay={(
                    <Popover id="" className="popover-simple-table popover-xl">
                      <table className="simple-table table table-striped table-condensed table-hover m-b-0">
                        <thead>
                        <tr>
                          <th>{t('ANALISIS_EXTRACCIONES.COLUMNS.FECHA')}</th>
                          <th>{t('ANALISIS_EXTRACCIONES.COLUMNS.VOL')}</th>
                          <th>{nameMotilidad}</th>
                          <th>{t('ANALISIS_EXTRACCIONES.COLUMNS.CONCENTRACION_TOTAL')}</th>
                          <th>{t('ANALISIS_EXTRACCIONES.COLUMNS.FORMAS_ANORMALES')}</th>
                          <th>{t('ANALISIS_EXTRACCIONES.COLUMNS.TIPO_DOSIS')}</th>
                          <th>{t('ANALISIS_EXTRACCIONES.COLUMNS.N_DOSIS_REALES')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                          extraccion.verraco.ultimasExtracciones && extraccion.verraco.ultimasExtracciones.length > 0 ? extraccion.verraco.ultimasExtracciones.map((extraccion, id) => {
                              return (
                                <tr key={id}>
                                  <td>{date_formatter(extraccion.fechaExtraccion, formaFechaHora, false)}</td>
                                  <td>{number_formatter(extraccion.volumen || 0, 2, separadorDec, separadorMil)}</td>
                                  <td>{number_formatter(extraccion[idMotilidad] || 0, 2, separadorDec, separadorMil)}</td>
                                  <td>{number_formatter(extraccion.concentracionTotal || 0, 2, separadorDec, separadorMil)}</td>
                                  <td>{number_formatter(extraccion.faTotalPercent || 0, 2, separadorDec, separadorMil)}</td>
                                  <td>{extraccion.nombreTipoDosis}</td>
                                  <td>{number_formatter(extraccion.dosisReales || 0, 0, separadorDec, separadorMil)}</td>
                                </tr>
                              )
                            }) :
                            (
                              <tr>
                                <td colSpan="7">{t(`COMUN.SIN_RESULTADOS`)}</td>
                              </tr>
                            )
                        }
                        </tbody>
                      </table>
                    </Popover>
                  )}>
                    <div onMouseOver={this.showOverlay} onMouseOut={this.hideOverlay}>
                      <Button type="button" className="btn-primary btn-input-style">
                        {t(tKey + 'FORM.ULTIMAS_5_EXTRACCIONES')}
                      </Button>
                    </div>
                  </OverlayTrigger>
                </Col>
              )}
              {!extraccion.verraco && this.props.panelControl.boxRfid && (
                <Col sm={4}>
                  <Button type="button" className="btn btn-white btn-input-style btn btn-default" onClick={()=>this.lecturaRFIDAnalisis()}>{t('RFID')}</Button>
                </Col>
              )}
            </Row>

          </Col>

          <Col sm={4}>

              <Col className="form-group read-only-fields" style={{paddingLeft: "15px", paddingTop: "10px", marginTop: "13px", lineHeight: "1.1", fontSize: "13px"}}>
                
                  <Row>
                    <Col sm={3}><p><b>{t(tKey + 'FORM.CODIGO')}</b></p></Col>
                    <Col sm={3}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.codigoAnalisis} </p></Col>
                    <Col sm={3}><p><b>{t(tKey + 'FORM.ORDEN')}</b></p></Col>
                    <Col sm={3}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.verraco && this.props.formAnalisisExtraccion.verraco.orden} </p></Col>
                  </Row>
                  <Row>
                    <Col sm={3}><p><b>{t(tKey + 'FORM.ESTADO')}</b></p></Col>
                    <Col sm={3}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.verraco && this.props.formAnalisisExtraccion.verraco.estadoverraco} </p></Col>
                    <Col sm={3}><p><b>{t(tKey + 'FORM.RAZA')}</b></p></Col>
                    <Col sm={3}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.verraco && this.props.formAnalisisExtraccion.verraco.nombreRaza} </p></Col>
                  </Row>
                  <Row>
                    <Col sm={3}><p><b>{t(tKey + 'FORM.INDEX')}</b></p></Col>
                    <Col sm={3}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.verraco && this.props.formAnalisisExtraccion.verraco.index} </p></Col>
                    <Col sm={3}><p><b>{t('FICHA_VERRACO.NUEVO_VERRACO.PARAMETROS.INDEX.MODAL.NIVEL_GENETICO')}</b></p></Col>
                    <Col sm={3}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.verraco && this.props.formAnalisisExtraccion.verraco.nivelGenetico} </p></Col>
                  </Row>
                  <Row>
                    <Col sm={3}><p><b>{t(tKey + 'FORM.LINEA_GENETICA')}</b></p></Col>
                    <Col sm={3}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.verraco && this.props.formAnalisisExtraccion.verraco.nombreLinea} </p></Col>
                    <Col sm={3}><p><b>{t(tKey + 'FORM.UBICACION')}</b></p></Col>
                    <Col sm={3}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.verraco && this.props.formAnalisisExtraccion.verraco.ubicacion} </p></Col>
                  </Row>
                  <Row>
                    <Col sm={3}><p><b>{t(tKey + 'FORM.PROPIEDAD')}</b></p></Col>
                    <Col sm={3}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.verraco && this.props.formAnalisisExtraccion.verraco.propiedad} </p></Col>
                  </Row>
              </Col>

            </Col>

        </Row>



       <hr/>


      <Row>
        <Col sm={4}>
          <Row>
            <Field
                colSm={6}
                id="volumen"
                name="volumen"
                controlLabel={t(tKey + 'FORM.VOLUMEN_ML') + '*'}
                component={InputNumerical}
                onInputChange={(event, val) => this.handleChangeVolumen(val)}
                onInputChangeDelay={true}
                onInputBlur={(event, val) => this.handleBlurVolumen(val)}
                validate={required}
                disabled={diluido}
                numDecimales={0}
                autoComplete="off"
              />
              <Col sm={6} key="volumenButton">
                <Button type="button" className="btn btn-white btn-input-style btn btn-default" onClick={()=>this.checkVolumen()}>{t(tKey + 'FORM.BASCULA')}</Button>
              </Col>
          </Row>

          <Row>

            <Field
                colSm={6}
                id="tipoAnalisis"
                name="tipoAnalisis"
                controlLabel={t(tKey + 'FORM.TIPO_ANALISIS')}
                component={InputSelect}
                options={comboTipoAnalisisExtraccion}
                valueKey="value"
                labelKey="label"
                isClearable={false}
                isSmall={true}
                onInputChange={(tipoAnalisisSeleccionado) => changeTipoAnalisisExtraccion(tipoAnalisisSeleccionado && tipoAnalisisSeleccionado.value)}
                disabled={false}
              />
              { tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.COLORIMETRO ? [
                <Field
                  colSm={6}
                  id="rectaCalibrado"
                  name="rectaCalibrado"
                  key="rectaCalibrado"
                  controlLabel={t(tKey + 'FORM.RECTAS')}
                  component={InputSelect}
                  options={comboRectaCalibrado}
                  valueKey="value"
                  labelKey="label"
                  isClearable={false}
                  isSmall={true}
                  onInputChange={(rectaCalibrado) => this.handleChangeRectaCalibrado(rectaCalibrado && rectaCalibrado.value)}
                  disabled={diluido}
                />,
                <Field
                  colSm={6}
                  id="lectura"
                  name="lectura"
                  key="lectura"
                  controlLabel={t(tKey + 'FORM.LECTURA')}
                  component={InputNumerical}
                  onInputFocus={(event, val) => this.handleFocusLecturaColorimetro(val)}
                  onInputChange={(event, val) => this.handleChangeLecturaColorimetro(val)}
                  //onInputBlur ={(event, val) => this.handleChangeLecturaColorimetro(val)}
                  onInputChangeDelay={true}
                  disabled={diluido}
                  autoComplete="off"
                  setMyRef={this.setLecturaRefFn}
                />,
                <Col sm={6} key="colorimetroButton">
                  <Button
                    type="button"
                    onClick={() => ((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1) && !diluido) && openModalContajeMaquinas(tipoAnalisisExtraccionConstants.COLORIMETRO, false) }
                    className={"btn btn-primary btn-input-style" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ANALISIS] < 2) || diluido ? ' disabled' : '')}
                  >{t(tKey + 'BUTTONS.CONTAR')}</Button>
                </Col>
              ] : tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.CAMARA_BURKER ? [
                  <Field
                    colSm={6}
                    id="contados"
                    name="contados"
                    key="contados"
                    controlLabel={t(tKey + 'FORM.ESPERMATOZOIDES_CONTADOS')}
                    component={InputNumerical}
                    disabled={true}
                  />,
                  <Col sm={6} key="camaraBurkerButton">
                    <Button
                      type="button"
                      onClick={() => ((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1) && !diluido) && openModalContajeMaquinas(tipoAnalisisExtraccionConstants.CAMARA_BURKER, false) }
                      className={"btn btn-primary btn-input-style" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ANALISIS] < 2) || diluido ? ' disabled' : '')}
                    >{t(tKey + 'BUTTONS.CONCENTRACION_FA')}</Button>
                  </Col>
              ] : (tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_I || tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_M || tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION || tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML) ? [
                <Col sm={6} key="openMagavisionButton">
                  <Button
                    type="button"
                    onClick={() => ((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1) && !diluido) && this.abrirMagavision(tipoAnalisisSeleccionado) }
                    className={"btn btn-primary btn-input-style" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ANALISIS] < 2) || diluido ? ' disabled' : '')}
                  >{t(tKey + 'BUTTONS.ABRIR_MAGAVISION')}</Button>
                </Col>,
                (tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_I || tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_M) && (
                  <Col sm={6} key="getMagavisionResultButton">
                    <Button
                      type="button"
                      onClick={() => ((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1) && !diluido) && this.obtenerYGuardarResultadoSistemaAnalisis() }
                      className={"btn btn-primary btn-input-style" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ANALISIS] < 2) || diluido ? ' disabled' : '')}
                    >{t(tKey + 'BUTTONS.EVALUACION')}</Button>
                  </Col>
                )
              ] :
              (tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.AI_STATION) ? [
                <Col sm={6} key="openAIStationButton">
                  <Button
                    type="button"
                    onClick={() => ((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1) && !diluido) && this.abrirAiStation() }
                    className={"btn btn-primary btn-input-style" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ANALISIS] < 2) || diluido ? ' disabled' : '')}
                  >{t(tKey + 'BUTTONS.ABRIR_AISTATION')}</Button>
                </Col>,
                (
                <Col sm={6} key="getAIStationResultButton">
                  <Button
                    type="button"
                    onClick={() => ((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1) && !diluido) && this.getAnalisisAiStation() }
                    disabled={!this.state.aiStationAbierto}
                    className={"btn btn-primary btn-input-style" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ANALISIS] < 2) || diluido ? ' disabled' : '')}
                  >{t(tKey + 'BUTTONS.CARGAR_ANALISIS_AISTATION')}</Button>
                </Col>)
              ] : null
            }
          </Row>
          
          <Row>
              {(
                tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_I || 
                tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_M || 
                tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION ||
                tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML ||
                tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.AI_STATION
                ) && (
                
                <Field
                  colSm={6}
                  id="contados"
                  name="contados"
                  key="contados"
                  controlLabel={t(tKey + 'FORM.ESPERMATOZOIDES_CONTADOS')}
                  component={InputNumerical}
                  disabled={true}
                />
                )
              }
              {(this.props.match.params.idAnalisisExtraccion && tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML) && (
                <Col sm={6} key="openMagavisionButton">
                <Button
                    type="button"
                    onClick={() => ((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1)) && this.verInformeMagavision(this.props.match.params.idAnalisisExtraccion) }
                    className={"btn btn-primary btn-input-style" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ANALISIS] < 2) ? ' disabled' : '')}
                  >{t(tKey + 'BUTTONS.VER_INFORME_MAGAVISION')}</Button>
                </Col>
              )}
          </Row>

          <ModalContajeMaquinasPage from={tipo.ANALISIS}/>
          
        </Col>
      
        <Col sm={4} className="border-left">
            <Row>
             {(
                tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.COLORIMETRO ||
                tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.CAMARA_BURKER
              ) && (
                <Field
                  colSm={6}
                  id="motilidadTotal"
                  name="motilidadTotal"
                  controlLabel={t(tKey + 'FORM.MOTILIDAD_PERCENT')}
                  component={InputNumerical}
                  onInputChange={(event, val) => this.handleChangeMotilidadTotal(val)}
                  onInputChangeDelay={true}
                  disabled={diluido}
                  autoComplete="off"
                />
              )}

                { (tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_M) && 
                  <Field
                    colSm={6}
                    id="motilidadMasal"
                    name="motilidadMasal"
                    key="motilidadMasal"
                    controlLabel={t(tKey + 'FORM.MOT_MASAL')}
                    component={InputNumerical}
                    disabled={true}
                  />
                }
                {
                (tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_I || tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION || tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML || tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.AI_STATION) && [
                  <Field
                    colSm={6}
                    id="mt"
                    name="mt"
                    key="mt"
                    controlLabel={t(tKey + 'FORM.MT')}
                    component={InputNumerical}
                    disabled={true}
                  />,
                  <Field
                    colSm={6}
                    id="mp"
                    name="mp"
                    key="mp"
                    controlLabel={t(tKey + 'FORM.MP')}
                    component={InputNumerical}
                    disabled={true}
                  />
                ]}                
              </Row>

            <Row>
                {(tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML || tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.AI_STATION) && [
                  <Field
                    colSm={6}
                    id="myn"
                    name="myn"
                    key="myn"
                    controlLabel={t(tKey + 'FORM.MYN')}
                    component={InputNumerical}
                    disabled={true}
                  />
                ]}
                {(tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML || tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.AI_STATION) ? [
                  <Field
                    colSm={6}
                    id="mc"
                    name="mc"
                    key="mc"
                    controlLabel={t(tKey + 'FORM.MOTILIDAD_CIRCULAR')}
                    component={InputNumerical}
                    disabled={true}
                  />
                ]:[
                  <Field
                    colSm={6}
                    id="calidad"
                    name="calidad"
                    controlLabel={t(tKey + 'FORM.CALIDAD')}
                    component={InputNumerical}
                    disabled={diluido}
                    autoComplete="off"
                  />
                ]}
                <Field
                  colSm={6}
                  id="aglutinacion"
                  name="aglutinacion"
                  controlLabel={t(tKey + 'FORM.AGLUTINACION')}
                  component={InputNumerical}
                  disabled={diluido}
                  autoComplete="off"
                />
                {(tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML || tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.AI_STATION) && [
                  <Field
                    colSm={6}
                    id="aglutinacionPercent"
                    name="aglutinacionPercent"
                    controlLabel={t(tKey + 'FORM.AGLUTINACION_PERCENT')}
                    component={InputNumerical}
                    disabled={diluido}
                    autoComplete="off"
                  />
                ]}
              </Row>

              <Row>
                <Field
                  colSm={6}
                  id="temperaturaEyaculado"
                  name="temperaturaEyaculado"
                  controlLabel={t(tKey + 'FORM.TEMPERATURA_EYACULADO')}
                  component={InputNumerical}
                  disabled={diluido}
                  autoComplete="off"
                />
                {this.props.auth.modulos.includes(modulosConstant.TRAZABILIDAD_BIOSEGURIDAD) && this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.tipoDosis && (
                  <Col sm={6}>
                    <ModalTrazabilidadMaterialPage/>
                    <Button
                      type="button"
                      className="btn btn-white btn-input-style btn btn-default"
                      disabled={this.state.loading}
                      onClick={!this.state.loading ? this.handleOpenModalTrazabilidadMaterial : null}
                    >
                      {stockInsuficiente && (<span className='help-block white'><Warning /></span>)} {t(tKey + 'BUTTONS.ACCEDER_TRAZABILIDAD_MATERIAL')}
                    </Button>
                  </Col>
                )}
              </Row>
        </Col>



        <Col sm={4}>
            <Field
              id="camposCalculados.buenos"
              name="camposCalculados.buenos"
              component="input"
              type="hidden"
            />
             <Col className="form-group read-only-fields" style={{paddingLeft: "15px", paddingTop: "10px", marginTop: "10px", lineHeight: "1.1", fontSize: "13px"}}>
               {(
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.MAGAVISION_I &&
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.MAGAVISION_M &&
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION &&
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.MAGAVISION_ML &&
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.AI_STATION
                ) &&
                ( <>
                    <Row>
                      <FormGroupSubtitle colSm={12} small={true}>
                            {t(tKey + 'FORM.ACROSOMAS_TOTAL')}
                      </FormGroupSubtitle>
                    </Row>
                    <Row>
                      <Col sm={4}><p><b>{t(tKey + 'FORM.ACROSOMAS')}</b></p></Col>
                      <Col sm={4}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.totalAcrosomas} </p></Col>
                      <Col sm={2}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.percentAcrosomas} </p></Col>
                      <Col sm={2}><p><b>{t(tKey + 'FORM.PERCENT')}</b></p></Col>
                    </Row>
                  </>
                )}

              <Row>
                <FormGroupSubtitle colSm={12} small={true}>
                      {t(tKey + 'FORM.FORMAS_ANORMALES')}
                </FormGroupSubtitle>
              </Row>
              {(
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.MAGAVISION_I &&
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.MAGAVISION_M &&
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION
                ) &&
                (
                <Row>
                  <Col sm={4}><p><b>{t(tKey + 'FORM.FORMAS_ANORMALES_CABEZAS')}</b></p></Col>
                  <Col sm={4}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faCabezas} </p></Col>
                  <Col sm={2}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faCabezasPercent} </p></Col>
                  <Col sm={2}><p><b>{t(tKey + 'FORM.PERCENT')}</b></p></Col>
                </Row>
                )}
                {
                (tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.MAGAVISION_ML &&
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.AI_STATION
                ) && (
                  <Row>
                    <Col sm={4}><p><b>{t(tKey + 'FORM.FORMAS_ANORMALES_COLAS')}</b></p></Col>
                    <Col sm={4}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faColas} </p></Col>
                    <Col sm={2}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faColasPercent} </p></Col>
                    <Col sm={2}><p><b>{t(tKey + 'FORM.PERCENT')}</b></p></Col>
                  </Row>
                )}
              {
                (tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML ||
                  tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.AI_STATION) && [
                  <Row>
                    <Col sm={4}><p><b>{t(tKey + 'FORM.FORMAS_ANORMALES_COLAS_PLEGADAS')}</b></p></Col>
                    <Col sm={4}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faColasPlegadas} </p></Col>
                    <Col sm={2}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faColasPlegadasPercent} </p></Col>
                    <Col sm={2}><p><b>{t(tKey + 'FORM.PERCENT')}</b></p></Col>
                  </Row>,                               
                  <Row>
                    <Col sm={4}><p><b>{t(tKey + 'FORM.FORMAS_ANORMALES_COLAS_OVILLO')}</b></p></Col>
                    <Col sm={4}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faColasOvillo} </p></Col>
                    <Col sm={2}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faColasOvilloPercent} </p></Col>
                    <Col sm={2}><p><b>{t(tKey + 'FORM.PERCENT')}</b></p></Col>
                  </Row>                 
                ]}
              <Row>
                <Col sm={4}><p><b>{t(tKey + 'FORM.FORMAS_ANORMALES_GOTA_PROXIMAL')}</b></p></Col>
                <Col sm={4}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faGotaProximal} </p></Col>
                <Col sm={2}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faGotaProximalPercent} </p></Col>
                <Col sm={2}><p><b>{t(tKey + 'FORM.PERCENT')}</b></p></Col>
              </Row>
              <Row>
                <Col sm={4}><p><b>{t(tKey + 'FORM.FORMAS_ANORMALES_GOTA_DISTAL')}</b></p></Col>
                <Col sm={4}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faGotaDistal} </p></Col>
                <Col sm={2}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faGotaDistalPercent} </p></Col>
                <Col sm={2}><p><b>{t(tKey + 'FORM.PERCENT')}</b></p></Col>
              </Row>
              {(
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.MAGAVISION_I &&
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.MAGAVISION_M &&
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION &&
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.MAGAVISION_ML &&
                  tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.AI_STATION
                ) &&
                (
                <Row>
                  <Col sm={4}><p><b>{t(tKey + 'FORM.FORMAS_ANORMALES_PIEZA_INTERMEDIA')}</b></p></Col>
                  <Col sm={4}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faPiezaIntermedia} </p></Col>
                  <Col sm={2}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faPiezaIntermediaPercent} </p></Col>
                  <Col sm={2}><p><b>{t(tKey + 'FORM.PERCENT')}</b></p></Col>
                </Row>
              )}
              <Row>
                <Col sm={4}><p><b>{t(tKey + 'FORM.FORMAS_ANORMALES_TOTAL')}</b></p></Col>
                <Col sm={4}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faTotal} </p></Col>
                <Col sm={2}><p>{this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.camposCalculados && this.props.formAnalisisExtraccion.camposCalculados.faTotalPercent} </p></Col>
                <Col sm={2}><p><b>{t(tKey + 'FORM.PERCENT')}</b></p></Col>
              </Row>

            </Col>
            {(tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML ||
              tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.AI_STATION) && [
              <Field
                id="dcl"
                name="dcl"
                component="input"
                type="hidden"
              />,
              <Field
                id="dsl"
                name="dsl"
                component="input"
                type="hidden"
              />,
              <Field
                id="dap"
                name="dap"
                component="input"
                type="hidden"
              />,
              <Field
                id="vcl"
                name="vcl"
                component="input"
                type="hidden"
              />,
              <Field
                id="vsl"
                name="vsl"
                component="input"
                type="hidden"
              />,
              <Field
                id="vap"
                name="vap"
                component="input"
                type="hidden"
              />,
              <Field
                id="str"
                name="str"
                component="input"
                type="hidden"
              />,
              <Field
                id="lin"
                name="lin"
                component="input"
                type="hidden"
              />,
              <Field
                id="wob"
                name="wob"
                component="input"
                type="hidden"
              />,
              <Field
                id="alh"
                name="alh"
                component="input"
                type="hidden"
              />,
              <Field
                id="bcf"
                name="bcf"
                component="input"
                type="hidden"
              />,
              <Field
                id="mad"
                name="mad"
                component="input"
                type="hidden"
              />,
              <Field
                id="velRapidos"
                name="velRapidos"
                component="input"
                type="hidden"
              />,
              <Field
                id="velMedios"
                name="velMedios"
                component="input"
                type="hidden"
              />,
              <Field
                id="velLentos"
                name="velLentos"
                component="input"
                type="hidden"
              />,
              <Field
                id="velEstaticos"
                name="velEstaticos"
                component="input"
                type="hidden"
              />,
              <Field
                id="tokenAnalisisMagavision"
                name="tokenAnalisisMagavision"
                component="input"
                type="hidden"
              />
            ]}

        </Col>
      </Row>
            

          </Col>




      </Row>

           <hr />
            
            <Row className="row-flex">
              <Col sm={12}>
                <Row className="row-flex">
                  <FormGroupSubtitle colSm={2} small={true} className="border-right">
                    {t(tKey + 'FORM.CONCENTRACION_MILLONES_ML')}
                  </FormGroupSubtitle>
                  <FormGroupSubtitle colSm={2} small={true} className="border-right">
                    {t(tKey + 'FORM.CONCENTRACION_SPZ_DOSIS')}
                  </FormGroupSubtitle>
                  <FormGroupSubtitle colSm={4} small={true} className="border-right">&nbsp;</FormGroupSubtitle>
                  <FormGroupSubtitle colSm={3} small={true} className={this.state.existsAnalisisExtraccion ? "border-right" : ""}>
                    {t(tKey + 'FORM.TOTALES')}
                  </FormGroupSubtitle>
                </Row>
              </Col>
              <Col sm={2} className="border-right">
                <Row>
                  <Field
                    colSm={12}
                    id="concentracionTotal"
                    name="concentracionTotal"
                    controlLabel={t(tKey + 'FORM.CONCENTRACION_TOTAL')}
                    component={InputNumerical}
                    disabled={true}
                  />
                  <Field
                    colSm={12}
                    id="concentracionUtil"
                    name="concentracionUtil"
                    controlLabel={t(tKey + 'FORM.CONCENTRACION_UTIL')}
                    component={InputNumerical}
                    disabled={true}
                  />
                </Row>
              </Col>
              <Col sm={2} className="border-right">
                <Row>
                  <Field
                    colSm={12}
                    id="concentracionXDosisAplicada"
                    name="concentracionXDosisAplicada"
                    controlLabel={t(tKey + 'FORM.CONCENTRACION_X_DOSIS_APLICADAS')}
                    component={InputNumerical}
                    numDecimales={4}
                    disabled={true}
                  />
                  <Field
                    colSm={12}
                    id="concentracionXDosisUtil"
                    name="concentracionXDosisUtil"
                    controlLabel={t(tKey + 'FORM.CONCENTRACION_X_DOSIS_UTIL')}
                    component={InputNumerical}
                    numDecimales={4}
                    onInputChange={(event, val) => this.handleChangeConcentracionXDosisUtil(val)}
                    disabled={diluido}
                  />
                </Row>
              </Col>
              <Col sm={2}>
                <Row>
                  <Field
                    colSm={12}
                    id="tipoDosis"
                    name="tipoDosis"
                    controlLabel={t(tKey + 'FORM.TIPO_DOSIS') + '*'}
                    component={InputSelect}
                    options={comboTipoDosis}
                    valueKey="value"
                    labelKey="label"
                    isClearable={false}
                    isSmall={true}
                    onInputChange={(tipoDosis) => this.handleChangeTipoDosis(tipoDosis)}
                    disabled={disabledTipoDosis}
                    validate={required}
                  />
                  <Field
                    colSm={12}
                    id="tipoDiluyente"
                    name="tipoDiluyente"
                    controlLabel={t(tKey + 'FORM.TIPO_DILUYENTE')}
                    component={InputSelect}
                    options={comboTipoDiluyente}
                    valueKey="value"
                    labelKey="label"
                    isClearable={false}
                    isSmall={true}
                    disabled={diluido}
                  />
                </Row>
              </Col>
              <Col sm={2} className="border-right">
                <Row>
                  <Field
                    colSm={12}
                    id="volumenDiluyente"
                    name="volumenDiluyente"
                    controlLabel={t(tKey + 'FORM.VOLUMEN_DILUYENTE')}
                    component={InputNumerical}
                    numDecimales={0}
                    minValue={0}
                    disabled={true}
                  />
                  {this.props.auth.customizations && this.props.auth.customizations.includes("Netpork") && (
                  <Field
                    colSm={12}
                    id="volumenPredilucion"
                    name="volumenPredilucion"
                    controlLabel={t(tKey + 'FORM.VOLUMEN_PREDILUCION')}
                    onInputChange={(event, val) => this.handleChangePredilucion(val)}
                    onInputChangeDelay={true}                   
                    component={InputNumerical}
                    numDecimales={0}
                    minValue={0}
                    disabled={diluido}
                  />
                  )}
                </Row>
              </Col>
              <Col sm={3} className={this.state.existsAnalisisExtraccion ? "border-right" : ""}>
                <Row>
                  <Col sm={12}>
                    <Row>
                      <Field
                        colSm={6}
                        id="dosisTeoricas"
                        name="dosisTeoricas"
                        controlLabel={t(tKey + 'FORM.DOSIS_TEORICAS')}
                        component={InputNumerical}
                        numDecimales={0}
                        disabled={true}
                      />
                      <Field
                        colSm={6}
                        id="dosisReales"
                        name="dosisReales"
                        controlLabel={t(tKey + 'FORM.DOSIS_REALES')}
                        component={InputNumerical}
                        onInputChange={(event, val) => this.handleChangeDosisReales(val)}
                        numDecimales={0}
                        disabled={this.state.disabledDosisReales === true ? true : disabledTipoDosis}
                      />
                    </Row>
                  </Col>
                  <Col sm={12}>
                    <Row>
                      <Field
                        colSm={6}
                        id="verraco.mediaUltimaDosis"
                        name="verraco.mediaUltimaDosis"
                        controlLabel={t(tKey + 'FORM.MEDIA_ULTIMAS_DOSIS')}
                        component={InputNumerical}
                        disabled={true}
                      />
                      <Field
                        colSm={6}
                        id="eyaculadoEliminado"
                        name="eyaculadoEliminado"
                        component={InputCheckBox}
                        claseActivo="onoffswitch-label"
                        controlLabel={t(tKey + 'FORM.EYACULADO_ELIMINADO')}
                        onInputChange={(values) => this.handleChangeEyaculadoEliminado(values)}
                        disabled={diluido}
                      />
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col sm={1}>
                <Row>
                  {this.state.existsAnalisisExtraccion && [
                    <Field
                      colSm={12}
                      id="seguimiento"
                      name="seguimiento"
                      key="seguimiento"
                      component={InputCheckBox}
                      claseActivo="onoffswitch-label"
                      controlLabel={t(tKey + 'FORM.SEGUIMIENTO')}
                      disabled={true}
                    />,
                    <Col sm={12} className="text-right" key="seguimiento_btn">
                      <Button type="button" className="btn btn-primary btn-input-style" onClick={() => this.handleOpenModalListadoSeguimiento() }>{t(tKey + 'BUTTONS.SEGUIMIENTO')}</Button>
                    </Col>
                  ]}
                </Row>
              </Col>
            </Row>
            
         
   
  
          <hr />
          <Row className="row-flex">
            <Field
              colSm={3}
              id="observaciones"
              name="observaciones"
              controlLabel={t(tKey + 'FORM.OBSERVACIONES')}
              component={InputTextArea}
            />
            <Field
              colSm={3}
              id="observacionFoso"
              name="observacionFoso"
              controlLabel={t(tKey + 'FORM.OBSERVACIONES_FOSO')}
              component={InputTextArea}
              disabled={true}
            />
            {this.state.eyaculadoEliminado && (
              <Field
                colSm={2}
                id="observacionesEyaculadoEliminado"
                name="observacionesEyaculadoEliminado"
                controlLabel={t(tKey + 'FORM.OBSERVACIONES_EYACULADO_ELIMINADO')}
                component={InputSelect}
                options={comboObservacionesEyaculadoEliminado}
                valueKey="value"
                labelKey="label"
                isClearable={false}
                isSmall={true}
              />
            )}
            <Col sm={this.state.eyaculadoEliminado ? 4 : 6} className="text-right">
              { this.state.customizacionUSA &&
                <Button
                  type="button"
                  className={"btn btn-primary" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ANALISIS] < 2) || this.state.eyaculadoEliminado || (this.props.extraccion.data.dilucionesNumero !== undefined && this.props.extraccion.data.dilucionesNumero > 1) || (this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.envasado == true && this.props.formAnalisisExtraccion.idPool == null) ? ' disabled' : '')}
                  onClick={() => (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1) && !this.state.eyaculadoEliminado && !(this.props.extraccion.data.dilucionesNumero !== undefined && this.props.extraccion.data.dilucionesNumero > 1) && !(this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.envasado == true && this.props.formAnalisisExtraccion.idPool == null) && this.handleAbrirModalPoolAnalisisExtraccion() }
                >
                  {t(tKey + 'BUTTONS.POOL')}
                </Button>
              }
              <Button
                type="button"
                className={"btn btn-primary" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ANALISIS] < 2) || this.state.eyaculadoEliminado || (this.props.extraccion.data.dilucionesNumero !== undefined && this.props.extraccion.data.dilucionesNumero > 1) ? ' disabled' : '')}
                onClick={() => (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1) && !this.state.eyaculadoEliminado && !(this.props.extraccion.data.dilucionesNumero !== undefined && this.props.extraccion.data.dilucionesNumero > 1)  && this.handleAbrirModalDilucionAnalisisExtraccion() }
              >
                {t(tKey + 'BUTTONS.DILUCION')}
              </Button>
              <Button
                type="button"
                className="btn btn-white"
                onClick={() => this.pdfEtiquetaExtraccion()}
              >
                {t(tKey + 'BUTTONS.PDF_ETIQUETA')}
              </Button>
              <Button
                type="button"
                className="btn btn-primary"
                onClick={() => this.imprimirEtiquetaPDF()}
              >
                {t(tKey + 'BUTTONS.IMPRIMIR_ETIQUETA')}
              </Button>                            
              { this.state.customizacionUSA &&
                <Button
                type="button"
                className="btn btn-primary"
                onClick={() => this.imprimirMiniEtiquetaAnalisis()}
              >
                {t(tKey + 'BUTTONS.IMPRIMIR_MINI_ETIQUETA')}
                </Button>
              }
              { this.state.customizacionUSA &&
                <Button 
                type="button" 
                className={"btn btn-primary" + ((this.props.formAnalisisExtraccion && this.props.formAnalisisExtraccion.envasado == true && this.props.formAnalisisExtraccion.idPool == null) ? ' disabled' : '')}
                onClick={() => this.imprimirMiniEtiquetaPool()}>
                  {t('POOL_EXTRACCIONES.FORM.BUTTONS.IMPRIMIR_MINI_ETIQUETA')}
                </Button>
              }
              {/*{!this.state.existsAnalisisExtraccion && (*/}
                <Button
                  type="button"
                  className={"btn btn-primary" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ANALISIS] < 2) || this.state.loading || this.state.processing || submitting ? ' disabled' : '')}
                  onClick={((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1) && !this.state.loading && !this.state.processing && !submitting) ? handleSubmit(this.guardarYNuevoAnalisisExtraccion) : () => {}}
                >
                  {t(tKey + 'BUTTONS.GUARDAR_Y_NUEVO')}
                </Button>
              {/*)}*/}
              <Button
                type="button"
                className={"btn btn-primary" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ANALISIS] < 2) || this.state.loading || this.state.processing || submitting ? ' disabled' : '')}
                onClick={((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1) && !this.state.loading && !this.state.processing && !submitting) ? handleSubmit(this.submitFormAnalisisExtraccion) : () => {}}
              >
                {t(tKey + 'BUTTONS.GUARDAR')}
              </Button>
              <Button
                type="button"
                className="btn btn-white"
              >
                <Link to={{pathname: '/AnalisisExtracciones', state: { from: this.props.location.pathname }}}>{t(tKey + 'BUTTONS.CANCELAR')}</Link>
              </Button>
              {
                this.props.auth.codLicencia == 'LLCPIC' ? (
                  <Row className="row-flex" style={{marginTop: "20px"}}>
                    <Field                
                      id="noAutoEnvasado"
                      name="noAutoEnvasado"
                      inline
                      colSm={12}                    
                      component={InputCheckBox}
                      claseActivo="onoffswitch-label"
                      controlLabel={t(tKey + 'FORM.NO_AUTO_ENVASADO')}
                      onInputChange={(values) => this.handleChangeNoAutoEnvasado(values)}
                      disabled={diluido}                  
                    />    
                  </Row>   
                ) : null
              }             
            </Col>
          </Row>
          </div>
          )}
        </form>       
   
     {!this.state.eyaculadoEliminado && (
          <>
            <ModalDilucionAnalisisExtraccionPage loadTrazabilidadMaterialModal={false} />
            <ModalPoolAnalisisExtraccionPage/> 
          </>
        )}
        {this.state.existsAnalisisExtraccion && (
          <ModalListadoSeguimientoPage />
        )}
      </SimplePage>
    </div>



    )
  }
}

export default (reduxForm({
  form: 'formAnalisisExtraccion',
  onSubmitFail
})(FormAnalisisExtraccion))